<template>
  <div>
    <el-form
      label-width="60px"
      ref="form"
      :model="form"
      label-position="right"
      size="mini"
    >
      <el-form-item label="日期：">
        <el-date-picker
          v-model="form.date"
          type="daterange"
          :clearable="false"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="渠道：" prop="channelId">
        <channel-selector
          placeholder="请选择"
          @ready="onChannelSelectorReady"
          @change="onChannelSelectorChange"
          ref="channelSelector"
        >
        </channel-selector>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="loadList()"
          style="margin-left: 10px"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="list"
      border
      size="small"
      style="width: 1231px"
      height="600px"
    >
      <el-table-column
        fixed="left"
        prop="date"
        label="日期"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="number"
        label="新增人数"
        align="center"
        width="80"
      >
      </el-table-column>
      <el-table-column
        v-for="val in 15"
        :key="val"
        prop="isCheck"
        :label="'+' + val + '天'"
        align="center"
        width="70"
      >
        <template slot-scope="scope">
          {{
            scope.row.retentions[val]
              ? (scope.row.retentions[val].rate * 100).toFixed(2) + "%"
              : ""
          }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");
import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      list: [], //

      form: {
        date: [
          new Date(new Date().setDate(new Date().getDate() - 16)).setHours(
            0,
            0,
            0,
            0
          ),
          new Date(new Date().setDate(new Date().getDate() - 1)).setHours(
            0,
            0,
            0,
            0
          ),
        ],
      },
    };
  },
  components: {
    ChannelSelector,
  },
  async created() {},

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.channel;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channel = newChannelId;
    },
    /**
     *
     */
    async loadList() {
      this.list = [];
      this.maxDiffDay = 0;
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/reportForms/queryAccountRetention`,
          {
            startAt: this.form.date[0],
            endAt: this.form.date[1],
            channel: this.form.channel,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      for (let item of listInResponse) {
        let retentionObj = {};
        for (let ite of item.retentions) {
          retentionObj[ite.diffDay] = ite;
        }
        this.list.push({
          id: item.id,
          date: item.date,
          number: item.number,
          channel: item.channel,
          retentions: retentionObj,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 0px 0;
}

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}
</style>